import { render } from "./LevelUpDialog.vue?vue&type=template&id=5f5e5496"
import script from "./LevelUpDialog.vue?vue&type=script&lang=js"
export * from "./LevelUpDialog.vue?vue&type=script&lang=js"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__